import { browserAgent } from './agent';
import type { BrowserLogger } from './browserLoggerTypes';

// gloss
const isProduction = (): boolean => {
  const env = typeof process !== 'undefined' ? process.env?.NEXT_PUBLIC_ENVIRONMENT : undefined;
  return env === 'production' || env === 'staging';
};

export const createBrowserLogger = (component: string): BrowserLogger => ({
  info: (message, attributes) => {
    try {
      browserAgent.addPageAction('BrowserLog', {
        ...attributes,
        severity: 'info',
        component,
        message,
      });
    } catch {
    }
  },

  warn: (message, attributes) => {
    try {
      browserAgent.addPageAction('BrowserLog', {
        ...attributes,
        severity: 'warn',
        component,
        message,
      });
    } catch {
    }
  },

  error: (messageOrError, attributes) => {
    try {
      if (typeof messageOrError === 'string') {
        const err = new Error(messageOrError);
        browserAgent.noticeError(err, { ...attributes, component });
        browserAgent.addPageAction('BrowserError', {
          ...attributes,
          severity: 'error',
          message: messageOrError,
          component,
        });
      } else {
        const err = messageOrError instanceof Error ? messageOrError : new Error(String(messageOrError));
        browserAgent.noticeError(err, { ...attributes, component });
        browserAgent.addPageAction('BrowserError', {
          ...attributes,
          severity: 'error',
          message: err.message,
          component,
        });
      }
    } catch {
    }
  },

  debug: (message, attributes) => {
    try {
      if (!isProduction()) {
        console.debug(`[${component}]`, message, attributes ?? '');
      }
    } catch {
    }
  },
});
